import {
  TRACKS_GROUP,
  TRACKS_FILTER_INTERVAL,
  TRACKS_FILTER_OUTFIT,
  TRACKS_HIDE,
  TRACKS_REVIEW,
  TRACKS_SEARCH,
  TRACKS_FILTER_TEAM,
} from '@/constants';

export default {
  canonicalPoints: state => state.canonicalPoints,
  filterGroup: state => state.filters[TRACKS_GROUP],
  filterHide: state => state.filters[TRACKS_HIDE],
  filterInterval: state => state.filters[TRACKS_FILTER_INTERVAL],
  filterNumbers: state => state.filters[TRACKS_SEARCH],
  filterOutfit: state => state.filters[TRACKS_FILTER_OUTFIT],
  filterReview: state => state.filters[TRACKS_REVIEW],
  filterTeam: state => state.filters[TRACKS_FILTER_TEAM],
  filters: state => state.filters,
  filteredItems: (_, getters, rootState) => {
    const outfits = rootState?.outfits?.items;

    if (!getters.items || !outfits.length) {
      return [];
    }

    const { filterHide, filterInterval, filterOutfit, filterReview, filterNumbers, filterTeam, items } = getters;
    const outfitId = outfits.find(el => el.id === filterOutfit)?.team_id;
    let currentFrame, fps, left, right;
    if (filterInterval) {
      currentFrame = rootState?.project?.currentFrame;
      fps = rootState?.project?.self?.fps;
      left = currentFrame - filterInterval * fps;
      right = currentFrame + filterInterval * fps;
    }

    return items.filter(el => {
      const includesInSearchFilter = el.player?.player_name?.toLowerCase().includes(filterNumbers.toLowerCase()) ||
        el.player?.player_number?.toLowerCase().includes(filterNumbers.toLowerCase());
      if (!includesInSearchFilter) {
        return
      }
      if (Number.isInteger(outfitId) && el.team_id !== outfitId) {
        return;
      }
      if (!!filterTeam && el.team.id !== filterTeam) {
        return;
      }
      if (filterHide.includes(el.id)) {
        return;
      }
      if (filterInterval) {
        const { length = 0, start = 0 } = el.intervals[0];
        const end = start + length;
        if (!((left <= end && end <= currentFrame) || (currentFrame <= start && start <= right))) {
          return;
        }
      }

      return filterReview ? el : !el.review_status;
    });
  },
  items: state => state.items,
  item: state => (pid, tid) => state.items.find(item => item.job_id === pid && item.track_id === tid),
  jerseysOverview: state => state.jerseysOverview,
  sort: state => state.sort,
  more: state => state.more,
  loading: state => state.loading,
  modalDetails: state => state.modal.details,
  modalType: state => state.modal.type,
  tableMode: state => state.tableMode,
  total: state => state.total,
};
